module.exports = "/images/isoEasy.svg";